module.exports = __webpack_public_path__ + "static/media/maxParties_250_500.079d31fe.png";